(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-invite-link-gutenberg-block', {

        // Block setup
        title: __('Discord Invite Link', 'discord-wordpress-plugin'),
        description: __('Block outputs an HTML invite link to the selected channel.', 'discord-wordpress-plugin'),
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#daa272" d="M300.833 188.021V75.2083C300.833 71.1346 299.345 67.6092 296.368 64.6322C293.391 61.6552 289.865 60.1667 285.792 60.1667H172.979C166.398 60.1667 161.776 63.222 159.113 69.3327C156.449 75.7567 157.546 81.2407 162.403 85.7845L196.247 119.628L70.7428 245.132C67.7658 248.109 66.2773 251.635 66.2773 255.708C66.2773 259.782 67.7658 263.308 70.7428 266.285L94.7155 290.257C97.6925 293.234 101.218 294.723 105.292 294.723C109.365 294.723 112.891 293.234 115.868 290.257L241.372 164.753L275.216 198.597C278.036 201.574 281.561 203.062 285.792 203.062C287.672 203.062 289.63 202.671 291.667 201.887C297.778 199.224 300.833 194.602 300.833 188.021ZM361 67.6875V293.312C361 311.958 354.38 327.901 341.14 341.14C327.901 354.38 311.958 361 293.312 361H67.6875C49.0421 361 33.0995 354.38 19.8597 341.14C6.6199 327.901 0 311.958 0 293.312V67.6875C0 49.0421 6.6199 33.0995 19.8597 19.8597C33.0995 6.6199 49.0421 0 67.6875 0H293.312C311.958 0 327.901 6.6199 341.14 19.8597C354.38 33.0995 361 49.0421 361 67.6875Z"/>
                <rect x="238" y="238" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            text: {
                type: 'string',
                default: __('here', 'discord-wordpress-plugin'),
            },
            link: {
                type: 'string',
                default: '0',
            },
            channels: []
        },


        // Main editor function
        edit: props => {

            // Updating channels list
            if (!props.attributes.channels || props.attributes.channels.length === 0) {
                $.get( ajaxurl, { action: 'dwpp_getAllChannelsList' } )
                    .done( response => {
                        let channels = [];
                        if (response.data.channels) {
                            response.data.channels.forEach(element => {
                                channels.push({
                                    value: element.id,
                                    label: element.name
                                });
                            });
                        }
                        props.setAttributes({ channels: channels });
                    } );

                return __('Loading...', 'discord-wordpress-plugin');
            }

            if (!props.attributes.link) {
                props.setAttributes({ link: props.attributes.channels[0].value });
                props.setAttributes({ text: props.attributes.channels[0].label });
            }


            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <TextControl
                                    label={ __('Link text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.text }
                                    onChange={ value => props.setAttributes({ text: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Invite to channel', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ link: value }) }
                                    options={ props.attributes.channels }
                                    value={ props.attributes.link }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <a className="dwpp__invite-link" href="javascript:void(0)">
                    { props.attributes.text }
                </a>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
